import * as sections from 'constants/sections';
import { i18n } from 'config/locales';
import { section } from 'config/locales/en/section';

export const LEGAL = {
  key: sections.LEGAL,
  name: 'legal',
  path: 'legal',
  store: 'Legal',
  label: i18n.t('legal.section.name'),
};

export const LEGAL_INTRO = {
  key: sections.LEGAL_INTRO,
  name: 'intro',
  path: 'intro',
  label: i18n.t('legal.subsection.intro'),
};

export const LEGAL_POLICE = {
  key: sections.LEGAL_POLICE,
  name: 'police',
  path: 'police',
  label: i18n.t('legal.subsection.police.label'),
};

export const LEGAL_POLICE_INTRO = {
  key: sections.LEGAL_POLICE_INTRO,
  name: 'police/intro',
  path: 'intro',
  label: i18n.t('legal.subsection.police.intro'),
};

export const LEGAL_POLICE_OFFENSES = {
  key: sections.LEGAL_POLICE_OFFENSES,
  name: 'police/offenses',
  path: 'offenses',
  storeKey: 'PoliceOffenses',
  label: i18n.t('legal.subsection.police.offenses'),
};

export const LEGAL_POLICE_ADDITIONAL_OFFENSES = {
  key: sections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
  name: 'police/additionaloffenses',
  path: 'additionaloffenses',
  storeKey: 'PoliceOtherOffenses',
  label: i18n.t('legal.subsection.police.additionalOffenses'),
};

export const LEGAL_POLICE_DOMESTIC_VIOLENCE = {
  key: sections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
  name: 'police/domesticviolence',
  path: 'domesticviolence',
  storeKey: 'PoliceDomesticViolence',
  label: i18n.t('legal.subsection.police.domesticViolence'),
};

export const LEGAL_CRIMINAL_CONVICTIONS = { //
  key: sections.LEGAL_CRIMINAL_CONVICTIONS,
  name: 'criminalConvictions',
  path: 'criminalConvictions', //
  storeKey: 'CriminalConvictions',
  label: i18n.t('legal.pvq.subsection.criminalconvictions'),
};

export const LEGAL_INVESTIGATIONS = {
  key: sections.LEGAL_INVESTIGATIONS,
  name: 'investigations',
  path: 'investigations',
  label: i18n.t('legal.subsection.investigations.label'),
};

export const LEGAL_INVESTIGATIONS_INTRO = {
  key: sections.LEGAL_INVESTIGATIONS_INTRO,
  name: 'investigations/intro',
  path: 'intro',
  label: i18n.t('legal.pvq.subsection.investigations.intro'),
};

export const LEGAL_INVESTIGATIONS_HISTORY = {
  key: sections.LEGAL_INVESTIGATIONS_HISTORY,
  name: 'investigations/history',
  path: 'history',
  storeKey: 'History',
  label: i18n.t('legal.subsection.investigations.history'),
};

export const LEGAL_INVESTIGATIONS_REVOKED = {
  key: sections.LEGAL_INVESTIGATIONS_REVOKED,
  name: 'investigations/revoked',
  path: 'revoked',
  storeKey: 'Revoked',
  label: i18n.t('legal.subsection.investigations.revoked'),
};

export const LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES = {
  key: sections.LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES,
  name: 'investigations/clearanceissues',
  path: 'clearanceissues',
  storeKey: 'ClearanceIssues',
  label: i18n.t('legal.subsection.investigations.clearanceissues'),
};

export const LEGAL_INVESTIGATIONS_DEBARRED = {
  key: sections.LEGAL_INVESTIGATIONS_DEBARRED,
  name: 'investigations/debarred',
  path: 'debarred',
  storeKey: 'Debarred',
  label: i18n.t('legal.subsection.investigations.debarred'),
};

export const LEGAL_INVESTIGATIONS_PIV_ISSUES = {
  key: sections.LEGAL_INVESTIGATIONS_PIV_ISSUES,
  name: 'investigations/pivissues',
  path: 'pivissues',
  storeKey: 'PivIssues',
  label: i18n.t('legal.subsection.investigations.piv'),
};

export const LEGAL_INVESTIGATIONS_FOREIGN = {
  key: sections.LEGAL_INVESTIGATIONS_FOREIGN,
  name: 'investigations/foreign',
  path: 'foreign',
  storeKey: 'Foreign',
  label: i18n.t('legal.subsection.investigations.foreign'),
};

export const LEGAL_COURT = {
  key: sections.LEGAL_COURT,
  name: 'court',
  path: 'court',
  storeKey: 'NonCriminalCourtActions',
  label: i18n.t('legal.subsection.court'),
};

export const LEGAL_TECHNOLOGY = {
  key: sections.LEGAL_TECHNOLOGY,
  name: 'technology',
  path: 'technology',
  label: i18n.t('legal.subsection.technology.label'),
};

export const LEGAL_HANDLING_PROTECTED_INFO = {
  key: sections.LEGAL_HANDLING_PROTECTED_INFO,
  name: 'technology/protected_info',
  path: 'technologyprotected',
  label: i18n.t('legal.pvq.protectedInformation.subsection.label'),
};
export const LEGAL_HANDLING_PROTECTED_INFO_INTRO = {
  key: sections.LEGAL_HANDLING_PROTECTED_INFO_INTRO,
  name: 'technologyprotected/intro',
  path: 'intro',
  label: i18n.t('legal.pvq.protectedInformation.subsection.intro'),
};

export const LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED = {
  key: sections.LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED,
  name: 'technologyprotected/protectedunauthorized',
  path: 'protectedunauthorized',
  storeKey: 'ProtectedUnauthorized',
  label: i18n.t('legal.pvq.protectedInformation.subsection.protected'),
};

export const LEGAL_TECHNOLOGY_NONCOMPLIANCE = {
  key: sections.LEGAL_TECHNOLOGY_NONCOMPLIANCE,
  name: 'technologyprotected/noncompliance',
  path: 'noncompliance',
  storeKey: 'NonCompliance',
  label: i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.label'),
};

export const LEGAL_TECHNOLOGY_INTRO = {
  key: sections.LEGAL_TECHNOLOGY_INTRO,
  name: 'technology/intro',
  path: 'intro',
  label: i18n.t('legal.pvq.subsection.technology.intro'),
};
export const LEGAL_TECHNOLOGY_UNAUTHORIZED = {
  key: sections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
  name: 'technology/unauthorized',
  path: 'unauthorized',
  storeKey: 'Unauthorized',
  label: i18n.t('legal.subsection.technology.unauthorized'),
};

export const LEGAL_TECHNOLOGY_MANIPULATING = {
  key: sections.LEGAL_TECHNOLOGY_MANIPULATING,
  name: 'technology/manipulating',
  path: 'manipulating',
  storeKey: 'Manipulating',
  label: i18n.t('legal.subsection.technology.manipulating'),
};

export const LEGAL_TECHNOLOGY_DENIED = {
  key: sections.LEGAL_TECHNOLOGY_DENIED,
  name: 'technology/denied',
  path: 'denied',
  storeKey: 'Denied',
  label: i18n.t('legal.pvq.subsection.technology.denied'),
};

export const LEGAL_TECHNOLOGY_UNLAWFUL = {
  key: sections.LEGAL_TECHNOLOGY_UNLAWFUL,
  name: 'technology/unlawful',
  path: 'unlawful',
  storeKey: 'Unlawful',
  label: i18n.t('legal.subsection.technology.unlawful'),
};

export const LEGAL_ASSOCIATIONS = {
  key: sections.LEGAL_ASSOCIATIONS,
  name: 'associations',
  path: 'associations',
  label: i18n.t('legal.subsection.associations.label'),
};

export const LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION = {
  key: sections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
  name: 'associations/terrorist-organization',
  path: 'terrorist-organization',
  storeKey: 'TerroristOrganization',
  label: i18n.t('legal.subsection.associations.terroristOrganization'),
};

export const LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP,
  name: 'associations/terrorist-organization-membership',
  path: 'terrorist-organization-membership',
  storeKey: 'TerroristOrganizationMembership',
  label: i18n.t('legal.pvq.subsection.associations.terroristOrganizationMembership'),
};

export const LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT,
  name: 'associations/terrorism-engagement',
  path: 'terrorism-engagement',
  storeKey: 'TerrorismEngagement',
  label: i18n.t('legal.pvq.subsection.associations.terrorismEngagement'),
};

export const LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY,
  name: 'associations/terrorism-advocacy',
  path: 'terrorism-advocacy',
  storeKey: 'TerrorismAdvocacy',
  label: i18n.t('legal.pvq.subsection.associations.terrorismAdvocacy'),
};

export const LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP,
  name: 'associations/rights-suppression-group',
  path: 'rights-suppression-group',
  storeKey: 'RightsSuppressionGroup',
  label: i18n.t('legal.pvq.subsection.associations.rightsSuppressionGroup'),
};

export const LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP,
  name: 'associations/violent-rights-suppression-group',
  path: 'violent-rights-suppression-group',
  storeKey: 'ViolentRightsSuppressionGroup',
  label: i18n.t('legal.pvq.subsection.associations.violentRightsSuppressionGroup'),
};

export const LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION,
  name: 'associations/violent-organization',
  path: 'violent-organization',
  storeKey: 'ViolentOrganization',
  label: i18n.t('legal.pvq.subsection.associations.violentOrganization'),
};

export const LEGAL_ASSOCIATIONS_VIOLENT_ACTS = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_VIOLENT_ACTS,
  name: 'associations/violent-acts',
  path: 'violent-acts',
  storeKey: 'ViolentActs',
  label: i18n.t('legal.pvq.subsection.associations.violentActs'),
};

export const LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY,
  name: 'associations/hate-crime-advocacy',
  path: 'hate-crime-advocacy',
  storeKey: 'HateCrimeAdvocacy',
  label: i18n.t('legal.pvq.subsection.associations.hateCrimeAdvocacy'),

};

export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM,
  name: 'associations/international-and-domestic-terrorism',
  path: 'international-and-domestic-terrorism',
  storeKey: 'InternationalAndDomesticTerrorism',
  label: i18n.t('legal.pvq.subsection.associations.internationalAndDomesticTerrorism'),
};

export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT,
  name: 'associations/international-and-domestic-terrorism-engagement',
  path: 'international-and-domestic-terrorism-engagement',
  storeKey: 'InternationalAndDomesticTerrorismEngagement',
  label: i18n.t('legal.pvq.subsection.associations.internationalAndDomesticTerrorismEngagement'),
};

export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION,
  name: 'associations/international-and-domestic-terrorism-association',
  path: 'international-and-domestic-terrorism-association',
  storeKey: 'InternationalAndDomesticTerrorismAssociation',
  label: i18n.t('legal.pvq.subsection.associations.internationalAndDomesticTerrorismAssociation'),
};

export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY = { // PVQ
  key: sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY,
  name: 'associations/international-and-domestic-terrorism-advocacy',
  path: 'international-and-domestic-terrorism-advocacy',
  storeKey: 'InternationalAndDomesticTerrorismAdvocacy',
  label: i18n.t('legal.pvq.subsection.associations.internationalAndDomesticTerrorismAdvocacy'),
};

export const LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM = {
  key: sections.LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
  name: 'associations/engaged-in-terrorism',
  path: 'engaged-in-terrorism',
  storeKey: 'EngagedInTerrorism',
  label: i18n.t('legal.subsection.associations.engagedTerrorism'),
};

export const LEGAL_ASSOCIATIONS_ADVOCATING = {
  key: sections.LEGAL_ASSOCIATIONS_ADVOCATING,
  name: 'associations/advocating',
  path: 'advocating',
  storeKey: 'Advocating',
  label: i18n.t('legal.subsection.associations.advocating'),
};

export const LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW = {
  key: sections.LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
  name: 'associations/membership-overthrow',
  path: 'membership-overthrow',
  storeKey: 'MembershipOverthrow',
  label: i18n.t('legal.subsection.associations.overthrow'),
};

export const LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE = {
  key: sections.LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
  name: 'associations/membership-violence-or-force',
  path: 'membership-violence-or-force',
  storeKey: 'MembershipViolence',
  label: i18n.t('legal.subsection.associations.violence'),
};

export const LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW = {
  key: sections.LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
  name: 'associations/activities-to-overthrow',
  path: 'activities-to-overthrow',
  storeKey: 'ActivitiesToOverthrow',
  label: i18n.t('legal.subsection.associations.activitiesOverthrow'),
};

export const LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION = {
  key: sections.LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,
  name: 'associations/terrorism-association',
  path: 'terrorism-association',
  storeKey: 'TerrorismAssociation',
  label: i18n.t('legal.subsection.associations.terrorismAssociation'),
};

export const LEGAL_REVIEW = {
  key: sections.LEGAL_REVIEW,
  name: 'review',
  path: 'review',
  label: i18n.t('legal.subsection.review'),
};

export default {
  LEGAL,
  LEGAL_INTRO,
  LEGAL_POLICE,
  LEGAL_POLICE_INTRO,
  LEGAL_POLICE_OFFENSES,
  LEGAL_POLICE_ADDITIONAL_OFFENSES,
  LEGAL_POLICE_DOMESTIC_VIOLENCE,
  LEGAL_CRIMINAL_CONVICTIONS, //
  LEGAL_INVESTIGATIONS,
  LEGAL_INVESTIGATIONS_INTRO,
  LEGAL_INVESTIGATIONS_HISTORY,
  LEGAL_INVESTIGATIONS_FOREIGN,
  LEGAL_INVESTIGATIONS_PIV_ISSUES,
  LEGAL_INVESTIGATIONS_REVOKED,
  LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES,
  LEGAL_INVESTIGATIONS_DEBARRED,
  LEGAL_COURT,
  LEGAL_TECHNOLOGY,
  LEGAL_HANDLING_PROTECTED_INFO, // PVQ ONLY
  LEGAL_HANDLING_PROTECTED_INFO_INTRO, // PVQ ONLY
  LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED, // PVQ ONLY
  LEGAL_TECHNOLOGY_NONCOMPLIANCE, // PVQ ONLY
  LEGAL_TECHNOLOGY_INTRO,
  LEGAL_TECHNOLOGY_UNAUTHORIZED,
  LEGAL_TECHNOLOGY_MANIPULATING,
  LEGAL_TECHNOLOGY_DENIED,
  LEGAL_TECHNOLOGY_UNLAWFUL,
  LEGAL_ASSOCIATIONS,
  LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
  LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP, // PVQ
  LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT, // PVQ
  LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY, // PVQ
  LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP, // PVQ
  LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP, // PVQ
  LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION, // PVQ
  LEGAL_ASSOCIATIONS_VIOLENT_ACTS, // PVQ
  LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY, // PVQ
  LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
  LEGAL_ASSOCIATIONS_ADVOCATING,
  LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
  LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
  LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
  LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,
  LEGAL_REVIEW,
};
